class ColorSwatches extends HTMLElement {
	constructor() {
		super();
		this.collectionProductWrapper = this.closest('.collection__products');
		this.productGridItem = this.closest('.product-grid-item');
		this.originalSwatches = this.productGridItem.querySelector('.original-swatches color-swatches');
		this.limitColorSwatchOptions();
		this.addEventListener('change', this.onColorSwatchChange);
	}

	onColorSwatchChange(ev) {
		let currentSwatch = ev.target;
		if (currentSwatch.tagName !== 'INPUT') currentSwatch = currentSwatch.querySelector('input');
		if (!currentSwatch) return;
		this.updateMasterDataset(currentSwatch);

		if (this.variantId) {
			this.renderProduct(currentSwatch);
		}
	}

	limitColorSwatchOptions() {
		const limit = 4;
		const allColorSwatchOptions = this.querySelectorAll('li.connected-product__swatch');
		if (!allColorSwatchOptions) return;
		const allColorSwatchLen = allColorSwatchOptions.length;
		if (allColorSwatchLen <= limit) return;
		const swatchArray = Array.from(allColorSwatchOptions);
		const excessSwatches = swatchArray.slice(limit);
		excessSwatches.forEach(swatch => swatch.remove());

		const moreSwatch = document.createElement('li');
		moreSwatch.className = 'connected-product__swatch more-swatch';
		moreSwatch.textContent = '+';

		swatchArray[limit - 1].parentNode.appendChild(moreSwatch);
		
		moreSwatch.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const cardWrapper = moreSwatch.closest('.product-grid-item__inner');
      const productLink = cardWrapper?.querySelector('a[href*="/products/"]');
      if (productLink) productLink.click();
    });
	}

	updateProductOptions() {
		try {
			const fieldsets = Array.from(this.querySelectorAll('fieldset'));
			if (!fieldsets) return;
			this.options = fieldsets.map((fieldset) => {
				return {
					value: Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value,
					connectedProductId: Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).dataset.connectedProductId,
					connectedProductHandle: Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).dataset.handle,
				};
			});
		}
		catch (e) {
			console.warn("error:", e)
		}
	}

	updateMasterDataset(currentSwatch) {
		this.productId = currentSwatch.dataset.connectedProductId;
		this.variantId = currentSwatch.dataset.connectedVariantId;
		this.productHandle = currentSwatch.dataset.handle;
	}

	async renderProduct(currentSwatch) {
		try {
			const response = await fetch(`/products/${this.productHandle}?section_id=product-grid-item-section`);
			const responseText = await response.text();
			const parsedHtml = new DOMParser().parseFromString(responseText, 'text/html');
			const productGridItem = parsedHtml.querySelector('.product-grid-item .product-grid-item__inner ');
			this.renderNewSwatches(productGridItem, currentSwatch);

		} catch (error) {
			console.error("Error fetching product data", error);

		}


	}

	renderNewSwatches(productGridItem, currentSwatch) {
		const newGridItem = this.closest('.product-grid-item .product-grid-item__inner');
		newGridItem.innerHTML = productGridItem.innerHTML;
		const newColorSwatches = newGridItem.querySelector('color-swatches');
		newColorSwatches.innerHTML = this.originalSwatches.innerHTML;
		this.activateSwatch(newColorSwatches, currentSwatch);
	}

	activateSwatch(newColorSwatches, currentSwatch) {
		const currentSwatchVariantId = currentSwatch.dataset.connectedVariantId;
		const newColorSwatchesElements = newColorSwatches.querySelectorAll('li input');
		newColorSwatchesElements.forEach((swatch) => {
			swatch.classList.remove('selected');
		});
		const newColorSwatchesElementsArray = [...newColorSwatchesElements];
		newColorSwatchesElementsArray.find((swatch) => swatch.dataset.connectedVariantId === currentSwatchVariantId).classList.add('selected');
	}

}

ColorSwatches.productData = [];

customElements.define('color-swatches', ColorSwatches);